import React from "react";
import NavBar from "../components/NavBar";

const TrainsEscapeSupportPage = ({ language, onLanguageChange, t }) => {
  const contactItems = t("trainsSupport.contactDetails.details") || [];
  const issues = t("trainsSupport.commonIssues.items") || [];

  return (
    <div
      className="page foody-page trains-page support-page"
      id="trains-support-top"
    >
      <NavBar
        language={language}
        onLanguageChange={onLanguageChange}
        items={[{ href: "/apps/trainsescape", label: t("trainsSupport.back") }]}
      />

      <main className="foody-main">
        <section className="foody-hero support-hero">
          <div className="foody-hero-copy">
            <span className="support-pill">{t("trainsSupport.badge")}</span>
            <h1>{t("trainsSupport.hero.title")}</h1>
            <p>
              {t("trainsSupport.hero.descPrefix")}{" "}
              <strong>Trains Escape</strong>?{" "}
              {t("trainsSupport.hero.descSuffix")}
            </p>
            <p className="support-muted">{t("trainsSupport.hero.updatedAt")}</p>
          </div>
        </section>

        <section className="foody-section">
          <div className="foody-grid support-grid">
            <article className="foody-card">
              <h3>{t("trainsSupport.contact.title")}</h3>
              <p>{t("trainsSupport.contact.emailLabel")}</p>
              <p>
                <a href="mailto:support-trainsescape@wodaslabs.com">
                  support-trainsescape@wodaslabs.com
                </a>
              </p>
              <p className="support-muted">
                {t("trainsSupport.contact.responseTime")}
              </p>
            </article>

            <article className="foody-card">
              <h3>{t("trainsSupport.contactDetails.title")}</h3>
              <p>{t("trainsSupport.contactDetails.subtitle")}</p>
              <ul className="support-list">
                {contactItems.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </article>

            <article className="foody-card">
              <h3>{t("trainsSupport.commonIssues.title")}</h3>
              <ul className="support-list">
                {issues.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </article>

            <article className="foody-card">
              <h3>{t("trainsSupport.links.title")}</h3>
              <p>
                <a href="https://wodaslabs.com">
                  {t("trainsSupport.links.home")}
                </a>
              </p>
              <p>
                <a href="https://wodaslabs.com/apps/trainsescape/static/privacy">
                  {t("trainsSupport.links.privacy")}
                </a>
              </p>
              <p>
                <a href="https://wodaslabs.com/apps/trainsescape/static/terms">
                  {t("trainsSupport.links.terms")}
                </a>
              </p>
            </article>
          </div>
        </section>

        <section className="foody-cta">
          <div>
            <h2>{t("trainsSupport.footer.title")}</h2>
            <p>
              {t("trainsSupport.footer.desc")}
              <br />
              <a href="mailto:support-trainsescape@wodaslabs.com">
                support-trainsescape@wodaslabs.com
              </a>
            </p>
          </div>
          <div className="store-badges foody-store-badges">
            <a
              className="btn primary"
              href="mailto:support-trainsescape@wodaslabs.com"
            >
              {t("trainsSupport.footer.emailButton")}
            </a>
          </div>
        </section>
      </main>
    </div>
  );
};

export default TrainsEscapeSupportPage;
